import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchOrganizationId } from "../../redux/organizationID/organizationIDActions";
import { fetchSessions } from "../../redux/session/sessionActions";
import { getUserOrganizations } from "../../services/OrganizationService";
import { enqueueSnackbar } from "notistack";
import { getPermissionsByUser } from "../../services/RolePermissionService";
import Select from "../../components/Select/Select";

const Organization = () => {
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("organization_id") || "",
  );
  const [organizationData, setOrganizationData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOrganizationId(selectedOrg || "1"));
    getOrganizations();
  }, [dispatch, selectedOrg]);

  const getOrganizations = async () => {
    try {
      const response = await getUserOrganizations();
      if (response.status === 200) {
        const organizationData = response.data.data;
        localStorage.setItem(
          "organizationData",
          JSON.stringify(organizationData),
        );
        setOrganizationData(organizationData);
      } else {
        console.error("Request was not successful:", response);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const fetchPermissions = async () => {
    try {
      const response = await getPermissionsByUser();
      if (response.status === 200) {
        localStorage.setItem("permissions", JSON.stringify(response.data.data));
      } else {
        console.error("Request was not successful:", response);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const orgID = event.target.value;
    localStorage.setItem("organization_id", orgID);
    localStorage.removeItem("session_id");
    axios.defaults.headers.common = { "organization-id": orgID };
    dispatch(fetchSessions());
    setSelectedOrg(orgID);
    enqueueSnackbar("Please select session", { variant: "error" });
    fetchPermissions();

    const selectedOrganization = organizationData.find(
      (org) => String(org.id) === String(orgID),
    );
    const organization_code = selectedOrganization?.organization_code;

    if (organization_code) {
      localStorage.setItem("org_code", organization_code);
    } else {
      localStorage.removeItem("org_code");
    }

    if (!orgID) {
      enqueueSnackbar("Please select school", { variant: "error" });
    }
  };

  return (
    <Select
      name="organization_id"
      value={selectedOrg}
      className="form-select"
      onChangeHandler={handleChange}
      options={organizationData}
    />
  );
};

export default Organization;
